// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-icon[data-v-1fdecfc8] {\n  vertical-align: middle;\n}\n.is-active[data-v-1fdecfc8] {\n  transform: rotate(180deg);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
